/**
 * Created by Teo on 27/08/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('hospitalizationTypeParents', {
                parent: 'masterData',
                url: '/hospitalizationTypeParents',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_REC_ADMINISTRATOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/masterData/hospitalizationTypeParents/hospitalizationTypeParents.html',
                        controller: 'MDHospitalizationTypeParentsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('masterData');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
